import React, { useState, useEffect } from 'react';
import { LinearProgress } from '@mui/material';

export default function Loading() {
    const [progress, setProgress] = useState(0);

    // Loading Bar
    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 95) {
                    return 95;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 95);
            });
            }, 100);
        
            return () => {
                clearInterval(timer);
            };
    }, []);

    return (
        <div className='map-loading'>
            <div className='map-container'>
                <div className='map-loading-logo'/>
                <LinearProgress variant="determinate" value={progress} />
            </div>
        </div>
    )
}